import { Component, OnInit, ViewChild } from '@angular/core';
import { PoModalAction, PoModalComponent } from '@po-ui/ng-components';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild('mensagemGov', { static: true }) mensagemGov: PoModalComponent;
  @ViewChild('mensagemInclusao', { static: true }) mensagemInclusao: PoModalComponent;
  @ViewChild('mensagemProcesso', { static: true }) mensagemProcesso: PoModalComponent;
  

  public informacoes: any;
  public fornecedor = '';
  public mensagem = "";
  public nivelPj = "";
  public isNivelQuatro = false;

  modalAction: PoModalAction = {
    label: "OK",
    action: () => {
      this.mensagemInclusao.close()
      this.mensagemProcesso.open()
      
      
    }
  };
  modalAction2: PoModalAction = {
    label: "OK",
    action: () => {
      this.mensagemGov.close()
      this.mensagemInclusao.open()
      
    }
  };

  constructor(
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    this.sessionService.info$
      .subscribe((data) => {
        this.informacoes = data;
        this.nivelPj = this.informacoes.FORNECEDOR[0].A2_XNIVLPJ;
        this.isNivelQuatro = this.nivelPj === "4";
        this.mensagemGov.open()
        
       
      });
    this.fornecedor = ` ${this.informacoes.FORNECEDOR[0].A2_NOME}`;
  }

}
